import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '../../../../../components';
import './Banner.scss';

function Banner({ picture }) {
  return (
    <div className="banner-container">
      {picture ? (
        <Image
          src={picture.src || picture}
          alt="venue-img"
          className="dashboard__banner banner-venueb"
        />
      ) : (
        <div className="empty-banner" />
      )}
    </div>
  );
}

Banner.defaultProps = {
  picture: null,
};

Banner.propTypes = {
  picture: PropTypes.string,
};

export default Banner;
